//core
import { createSelector } from "@reduxjs/toolkit";

//store
import { RootState } from "../../index";
import { createCachedSelector } from "re-reselect";

// state
const listSelector = (state: RootState) => state.admin.flatFee.list;
const listDataSelector = (state: RootState) => state.admin.flatFee.list.data;
const listErrorSelector = (state: RootState) => state.admin.flatFee.list.error;
const listFetchingSelector = (state: RootState) => state.admin.flatFee.list.isFetching;

//selectors
export const selectList = createSelector(listSelector, (list) => list);
export const selectListData = createSelector(listDataSelector, (data) => {
  if (!!data) {
    const columns = data.columns.map((item: any) => {
      if (item.name === 'description') {
        return { ...item, type: 'mediumString' };
      }
			if (item.name === 'status') {
        return { ...item, type: 'status' };
      }
			if (item.name === 'amount') {
        return { ...item, type: 'flatFeeAmount' };
      }
			if (item.name === 'affiliate_id') {
        return { ...item, type: 'clickableUserId' };
      }
			if (item.name === 'tracker_id') {
        return { ...item, type: 'clickableTrackerId' };
      }
			if (item.name === 'target_date') {
        return { ...item, type: 'datetime' };
      }
			if (item.name === 'id') {
        return { ...item, type: 'string' };
      }
      if (item.name === 'payment_type') {
        return { ...item, type: 'stringWithPrefixNowrap', prefix: 'admin.flatFee.form.options.paymentTypes.'};
      }
      if (item.name === 'payment_status') {
        return { ...item, type: 'stringWithPrefixNowrap', prefix: 'admin.flatFee.form.options.paymentStatus.'};
      }

      return item;
    });

    return {
      ...data,
      columns: [
        ...columns
      ],
    };
  } else {
    return data;
  }
});
export const selectListDataColumnsSort = createSelector(listDataSelector, (data) => {
  return data?.columns.filter((el: any) => el.sort === true)
});
export const selectListError = createSelector(listErrorSelector, (error) => error);
export const selectListIsFetching = createSelector(listFetchingSelector, (isFetching) => isFetching);

//Delete Flat Fee
const deleteFlatFeeDataSelector = (state: RootState) => state.admin.flatFee.deleteFlatFee.data;
const deleteFlatFeeErrorSelector = (state: RootState) => state.admin.flatFee.deleteFlatFee.error;
const deleteFlatFeeFetchingSelector = (state: RootState) => state.admin.flatFee.deleteFlatFee.isFetching;

export const selectDeleteData = createSelector(deleteFlatFeeDataSelector, (data) => data);
export const selectDeleteError = createSelector(deleteFlatFeeErrorSelector, (error) => error);
export const selectDeleteIsFetching = createSelector(deleteFlatFeeFetchingSelector, (isFetching) => isFetching);

//Create Flat Fee
const createFlatFeeDataSelector = (state: RootState) => state.admin.flatFee.createFlatFee.data;
const createFlatFeeErrorSelector = (state: RootState) => state.admin.flatFee.createFlatFee.error;
const createFlatFeeFetchingSelector = (state: RootState) => state.admin.flatFee.createFlatFee.isFetching;

export const selectCreateData = createSelector(createFlatFeeDataSelector, (data) => data);
export const selectCreateError = createSelector(createFlatFeeErrorSelector, (error) => error);
export const selectCreateIsFetching = createSelector(createFlatFeeFetchingSelector, (isFetching) => isFetching);

//Update Flat Fee
const updateFlatFeeDataSelector = (state: RootState) => state.admin.flatFee.updateFlatFee.data;
const updateFlatFeeErrorSelector = (state: RootState) => state.admin.flatFee.updateFlatFee.error;
const updateFlatFeeFetchingSelector = (state: RootState) => state.admin.flatFee.updateFlatFee.isFetching;

export const selectUpdateData = createSelector(updateFlatFeeDataSelector, (data) => data);
export const selectUpdateError = createSelector(updateFlatFeeErrorSelector, (error) => error);
export const selectUpdateIsFetching = createSelector(updateFlatFeeFetchingSelector, (isFetching) => isFetching);

//Download Flat Fee
const downloadFlatFeeDataSelector = (state: RootState) => state.admin.flatFee.download.data;
const downloadFlatFeeErrorSelector = (state: RootState) => state.admin.flatFee.download.error;
const downloadFlatFeeFetchingSelector = (state: RootState) => state.admin.flatFee.download.isFetching;

export const selectDownloadData = createSelector(downloadFlatFeeDataSelector, (data) => data);
export const selectDownloadError = createSelector(downloadFlatFeeErrorSelector, (error) => error);
export const selectDownloadIsFetching = createSelector(downloadFlatFeeFetchingSelector, (isFetching) => isFetching);

//getPayoutsList
const getPayoutsListDataSelector = (state: RootState) => state.admin.flatFee.payoutsList.data;
const getPayoutsListErrorSelector = (state: RootState) => state.admin.flatFee.payoutsList.error;
const getPayoutsListFetchingSelector = (state: RootState) => state.admin.flatFee.payoutsList.isFetching;
export const selectGetPayoutsListData = createSelector(getPayoutsListDataSelector, (data) => {
  if (!!data) {
    let columns = data.columns.map((item: any) => {
      if (item.name === 'paidAt') {
        return { ...item, type: "fulldatetime" };
      }

      // if (item.name === 'amount') {
      //   return { ...item, name: "paid_amount" };
      // }

      if (item.name === 'comment') {
        return { ...item, type: "mediumString" };
      }

      if (item.name === 'paidByUsername') {
        return { ...item, type: "string" };
      }

      if (item.type === 'stringWithPrefix') {
        return {
          ...item,
          prefix: 'common.components.payment.payment_method_options.'
        };
      }

      return item;
    });

    const list = data.list.map((item: any) => {
      return {
        ...item,
        paidAt: item.paymentDate,
        amountNoRecalculatable: item.amount,
        walletAmountNoRecalculatable: item.walletAmount,
      };
    });

    const isRecalculatableСolumns = data.columns.filter((item:any) => item.isRecalculatable);
    const isRecalculatableList = list.reduce((acc: any[], item: any) => {

      if (!!isRecalculatableСolumns.length && !!data.rate_currency) {
        const obj = isRecalculatableСolumns.reduce((object:any, recalculatableItem:any) => {

          if (item.hasOwnProperty(recalculatableItem.name) && !!item[recalculatableItem.name]) {
            const columnValue = new Big(item[recalculatableItem.name])
            const rateValue = new Big(data.rate_currency.value)
            const newValue =  columnValue.times(rateValue);
            return {...object, [recalculatableItem.name]: (parseInt(String(newValue * 100))) / 100};
          } else {
            return {...object, [recalculatableItem.name]: item.name};
          }

        }, {});
        acc.push({
          ...item,
          ...obj,
        });
        return acc;
      } else {
        acc.push({
          ...item,
        });
        return acc;
      }
    }, []);


    return { ...data, columns: columns, list: isRecalculatableList, };
  } else {
    return data
  }

  return data;
});
export const selectGetPayoutsListError = createSelector(getPayoutsListErrorSelector, (error) => error);
export const selectGetPayoutsListIsFetching = createSelector(getPayoutsListFetchingSelector, (isFetching) => isFetching);

//createPayout
const createPayoutDataSelector = (state: RootState) => state.admin.flatFee.createPayout.data;
const createPayoutErrorSelector = (state: RootState) => state.admin.flatFee.createPayout.error;
const createPayoutFetchingSelector = (state: RootState) => state.admin.flatFee.createPayout.isFetching;
export const selectCreatePayoutData = createSelector(createPayoutDataSelector, (data) => data);
export const selectCreatePayoutError = createSelector(createPayoutErrorSelector, (error) => error);
export const selectCreatePayoutIsFetching = createSelector(createPayoutFetchingSelector, (isFetching) => isFetching);

//updatePayout
const updatePayoutDataSelector = (state: RootState) => state.admin.flatFee.updatePayout.data;
const updatePayoutErrorSelector = (state: RootState) => state.admin.flatFee.updatePayout.error;
const updatePayoutFetchingSelector = (state: RootState) => state.admin.flatFee.updatePayout.isFetching;
export const selectUpdatePayoutData = createSelector(updatePayoutDataSelector, (data) => data);
export const selectUpdatePayoutError = createSelector(updatePayoutErrorSelector, (error) => error);
export const selectUpdatePayoutIsFetching = createSelector(updatePayoutFetchingSelector, (isFetching) => isFetching);

//removePayout
const removePayoutDataSelector = (state: RootState) => state.admin.flatFee.removePayout.data;
const removePayoutErrorSelector = (state: RootState) => state.admin.flatFee.removePayout.error;
const removePayoutFetchingSelector = (state: RootState) => state.admin.flatFee.removePayout.isFetching;
export const selectRemovePayoutData = createSelector(removePayoutDataSelector, (data) => data);
export const selectRemovePayoutError = createSelector(removePayoutErrorSelector, (error) => error);
export const selectRemovePayoutIsFetching = createSelector(removePayoutFetchingSelector, (isFetching) => isFetching);

//Payment change
const paymentChangeDataSelector = (state: RootState) => state.admin.flatFee.paymentChange.data;
export const selectPaymentChangeData = createSelector(paymentChangeDataSelector, (data) => data);

const paymentChangeErrorSelector = (state: RootState) => state.admin.flatFee.paymentChange.error;
export const selectPaymentChangeError = createSelector(paymentChangeErrorSelector, (error) => error);

//getAvailablePayments
const getAvailablePaymentsDataSelector = (state: RootState) => state.admin.flatFee.availablePayments.data;
const getAvailablePaymentsErrorSelector = (state: RootState) => state.admin.flatFee.availablePayments.error;
const getAvailablePaymentsFetchingSelector = (state: RootState) => state.admin.flatFee.availablePayments.isFetching;
export const selectGetAvailablePaymentsData = createSelector(getAvailablePaymentsDataSelector, (data) => {
  if (!!data) {
    const new_data = data.map((item: any) => {
      return {
        ...item,
        id: item.paymentMethodValue[item.defaultField],
        showValue: item.paymentMethodValue[item.defaultField],
      };
    });

    return new_data;
  } else {
    return data
  }

  return data;
});
export const selectGetAvailablePaymentsError = createSelector(getAvailablePaymentsErrorSelector, (error) => error);
export const selectGetAvailablePaymentsIsFetching = createSelector(getAvailablePaymentsFetchingSelector, (isFetching) => isFetching);

//getAvailablePaymentsList
const getAvailablePaymentsListDataSelector = (state: RootState) => state.admin.flatFee.availablePaymentsList.data;
const getAvailablePaymentsListErrorSelector = (state: RootState) => state.admin.flatFee.availablePaymentsList.error;
const getAvailablePaymentsListFetchingSelector = (state: RootState) => state.admin.flatFee.availablePaymentsList.isFetching;
export const selectGetAvailablePaymentsListData = createCachedSelector(
  (state: RootState) => state.admin.flatFee.availablePaymentsList.data,
  (_: RootState, affiliateId: number) => affiliateId,
  (allData, affiliateId) => {
    const list = allData?.[affiliateId]?.list ?? allData?.[affiliateId] ?? [];
    console.log('list', list)
    return list.map((item: any) => ({
      isDefault: item.isDefault,
      paymentMethodName: item.paymentMethod.name,
      paymentMethodValue: item.value,
      defaultField: item.paymentMethod.defaultField,
      walletCurrency: item.paymentMethod.currency || null,
      isAutoPaymentEnabled: item.paymentMethod.isAutoPaymentEnabled,
      id: item.value[item.paymentMethod.defaultField],
      showValue: item.value[item.paymentMethod.defaultField],
    }));
  }
)(
  (_: RootState, affiliateId: number) => (affiliateId ?? 0).toString()
);

export const selectGetAvailablePaymentsListError = createSelector(getAvailablePaymentsListErrorSelector, (error) => error);
export const selectGetAvailablePaymentsListIsFetching = createSelector(getAvailablePaymentsListFetchingSelector, (isFetching) => isFetching);
